export const HISTORY_TYPE = {
    NO_HISTORY: "POP"
}

export const PREMIUM_TIME_OPTIONS = {
    OTHER: 4
}